var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 51,
    viewBox: "0 0 48 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_62_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.27 10.0126L33.7074 30.8649L16.4087 13.5227L37.27 10.0126Z",
    fill: "url(#paint0_linear_62_4)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 28,
    r: 15,
    fill: "url(#paint1_linear_62_4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2649 26.8305L19.7854 27.9119V27.9118C19.8281 27.9425 19.8797 27.9588 19.9327 27.9587C19.9633 27.959 19.9936 27.9535 20.022 27.9426C20.1014 27.9125 20.1595 27.8448 20.1758 27.7632L21.3042 22.2494V22.2493C21.3226 22.1612 21.2896 22.0704 21.2182 22.0133C21.1469 21.9571 21.0497 21.9434 20.9651 21.9778L14.7423 24.5333C14.6516 24.57 14.5918 24.6557 14.5901 24.7516C14.5883 24.8472 14.644 24.9351 14.7324 24.9762L16.2579 25.6826L16.8585 27.5981V27.6078C16.8622 27.6209 16.8678 27.6334 16.875 27.645C16.8746 27.6493 16.8746 27.6537 16.875 27.658C16.8847 27.6739 16.8963 27.6885 16.9097 27.7016C16.9232 27.7141 16.9382 27.7249 16.9544 27.734L16.9677 27.7421L17.0074 27.7582H17.0306H17.0304C17.0453 27.7598 17.0603 27.7598 17.0752 27.7582C17.1045 27.7582 17.1336 27.7532 17.1612 27.7436L17.1777 27.734C17.1987 27.7255 17.2182 27.7141 17.2356 27.6999L18.2649 26.8305ZM16.7542 25.6133L18.4286 24.5303L17.2225 25.7442C17.2098 25.7562 17.1986 25.7698 17.1895 25.7846C17.1885 25.7889 17.1885 25.7933 17.1895 25.7975C17.183 25.8072 17.1775 25.8175 17.1728 25.8282V25.8476V25.8703L17.0537 26.5071L16.7542 25.6133ZM17.5716 26.3375L17.8544 26.538L17.4706 26.8742L17.5716 26.3375ZM20.7252 22.6018L19.764 27.2976L18.3973 26.3277L17.7768 25.8863L20.386 23.2581C20.4781 23.1698 20.4856 23.0271 20.4031 22.9302C20.3206 22.8331 20.1758 22.814 20.07 22.8863L16.4434 25.2268L15.4506 24.7661L20.7252 22.6018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.013 34.8497C11.0222 34.8776 11.0367 34.9034 11.0561 34.9256C11.0671 34.9371 11.0793 34.9473 11.0926 34.9564C11.1343 34.9847 11.184 34.9999 11.2347 35H26.7511C26.8882 35 26.9993 34.8914 26.9993 34.7575V24.3962C27.0002 24.3805 27.0002 24.3648 26.9993 24.3493C26.9928 24.3294 26.984 24.3104 26.9729 24.2927L26.9613 24.2781L26.9316 24.2442L26.9133 24.2296L26.9018 24.2199L19.1388 19.0425C19.0545 18.9858 18.9432 18.9858 18.8591 19.0425L11.1058 24.2069L11.0943 24.2166L11.0761 24.2312L11.0463 24.2651L11.0347 24.2797V24.2798C11.0235 24.2975 11.0147 24.3164 11.0082 24.3363C11.0045 24.3517 11.0017 24.3674 11 24.3832V34.7638C11.0006 34.7903 11.0057 34.8165 11.0149 34.8414L11.013 34.8497ZM26.5028 34.2209L21.2992 29.5915L26.5028 24.9524V34.2209ZM20.932 29.9261L26.1125 34.5248H11.8834L17.0639 29.9244L18.8326 31.5003C18.9275 31.5813 19.0687 31.5813 19.1636 31.5003L20.932 29.9261ZM11.5011 34.2191V24.957L16.6964 29.5913L11.5011 34.2191ZM18.9977 19.5374L26.3503 24.4351L18.9977 30.9929L11.645 24.4351L18.9977 19.5374Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_62_4",
    x: 0,
    y: 10.0125,
    width: 41.27,
    height: 40.9875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_62_4"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_62_4",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_62_4",
    x1: 35.5,
    y1: 19.5,
    x2: 7.22755,
    y2: 25.3912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED0CBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD2C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_62_4",
    x1: 4,
    y1: 27.6667,
    x2: 34,
    y2: 27.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD2C79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED0CBD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.d98b0ef53f738f3978fb5eb9aa90ef2e.svg";
export { ForwardRef as ReactComponent };